<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import persistTableFilters from "@/mixins/persistTableFilters";
// import {required} from "vuelidate/lib/validators";
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Vue from "vue";
import axios from "axios";
import {FulfillingBouncingCircleSpinner} from 'epic-spinners'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
// import DatePicker from "vue2-datepicker";
import moment from "moment";

Vue.component('v-select', vSelect)

import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import {mapState} from "vuex";
import {authComputed} from "@/state/helpers";

// register the plugin on vue
import Toasted from 'vue-toasted';

Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Productos component
 */
export default {
  mixins: [persistTableFilters],
  persistConfig: {
    key: "productos_filtros",
    fields: ["search", "perPage", "searchLabel", "banderaAuto", "auto", "modelo"],
  },
  page: {
    title: "Productos",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
    // DatePicker
  },
  data() {
    return {
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: {
          "x-token": this.$store.state.authfack.user.token,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        }
      },
      formTi: {
        fecha_compra: new Date(),
        tiendaid: "",
        observaciones: '',
        tienda: "",
        proveedor: "",
        total: "",
        state: true,
        id: 0,
      },
      ubicacionModel: 0,
      arrayDepa: [],
      arrayEstante: [],
      estanteModel: 0,
      apiBase: process.env.VUE_APP_URL + "productos/get?tienda=" + this.$store.state.authfack.user.tienda ,
      fecha_inicio: "",
      fecha_fin: "",
      metododeBusqueda: true,
      rangode_fecha: "",
      cardexid: 0,
      variosmodelos: [],
      productredirec: "",
      repit_nombre: true,
      alertadatos: false,
      banderaAuto : false,
      dismissCountDown: 0,
      dismissSecs: 4,
      /*  arrayCategorias : [], */
      arrayPresentacion: [],
      arraySubPre: [],
      arrayMarcas: [],
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      css: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        pagination: {
          infoClass: 'pull-left',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: '',
          },
        }
      },
      formPro: {
        idproducto:0,
        nombre: "",
        existencia_actual: 0,
        descripcion: "",
        cantidad : 0 ,
        tienda: "",
        categoria: "",
        marca: null,
        presentacion: "",
        pasillo: '',
        estante: '',  
        bodega: null,
        subpresentation: [],
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Productos",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Productos",
          active: true,
        },
      ],
      cabezera: [
        { key: "Opciones", label: "Opciones", thClass: "cell1" },
        { key: "tienda", label: "tienda", thClass: "cell1" },
        { key: "ubicacion", label: "ubicacion", thClass: "cell1" },
        { key: "cantidad", label: "Cantidad", thClass: "cell1" },
        { key: "pasillo", label: "Pasillo", thClass: "cell1" },
        { key: "estante", label: "Estante", thClass: "cell1" },
      ],
  
      fields: [

        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
        {
          name: 'Img',
          title: 'Img',
          sortField: 'Img',
          width: "20%",
        },
        {
          name: 'producto.codigo_stock',
          title: 'Código',
          sortField: 'codigo_stock',
          width: "10%",
        },
        {
          name: 'producto.nombre_producto',
          title: 'Nombre',
          sortField: 'nombre_producto',
          width: "10%",
        },
        {
          name: 'existencia',
          title: 'Existencia',
          sortField: 'existencia_stock',
          width: "5%",
        },
        {
          name: 'estante',
          title: 'estante',
          sortField: 'Estante',
          width: "5%",
        },
        {
          name: 'pasillo',
          title: 'pasillo',
          sortField: 'Pasillo',
          width: "5%",
        },
        {
          name: 'precio_compra',
          title: 'Precio Compra',
          sortField: 'precio_compra',
          width: "10%",
        },
        {
          name: 'precio_venta',
          title: 'Precio Venta',
          sortField: 'precio_venta',
          width: "10%",
        },
        {
          name: "categoria",
          sortField: "categoria",
          title: "Categoría",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "marca",
          sortField: "marca",
          title: "Marca",
          titleClass: "",
          dataClass: "list-item-heading",
          width: "5%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
      ],
      searchType: [
        {nombre: "Producto", value: "producto"},
        {nombre: "Codigo", value: "codigo"},
        {nombre: "Auto", value: "auto"},
      ],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: 'X',
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },

        },
      },
      loadingtable: false,
      sortBy: "nombre_tienda",
      sortDesc: false,
      searchLabel: {nombre: "Producto", value: "producto"},
      filterLabel: {nombre: "Codigo", value: "codigo"},
      showModalL: false, //Loading
      showModalM: false,  //Modelos
      showModalE: false,  //Editar
      showModalN: false, //Nuevo registro
      showModalD: false, //Desactivar
      showModalA: false, //Activar
      showModalC: false, //Cardex
      data: [],
      items: [],
      arrayBodegas: [],
      pageOptions: [4, 10, 15, 20, 40, 80, 100],
      arrayDetalle:[],
      search: "",
      page: 1,
      perPage: 4,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
      index : 0,
      arrayAuto : [],
      arrayModelo : [],
      auto: null,
      totalInversion: 0,
      modelo: {
        id: 0,
        nombre_modelo: "",
      },
    };
  },
  validations: {
   
  },
  async mounted() {
    const usuario = this.$store.state.authfack.user;
    console.log("usuariao",usuario);
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      // axios({
      //   baseURL: this.apiUrl + "auth/checkToken",
      //   method: "POST",
      //   headers: {"x-token": usuario.token},
      // })
      //     .then((res) => {
      //       if (res.data.success) {
      //         // this.$router.push("/");
      //       }
      //     })
      //     .catch(() => {
      //       this.logout();
      //       location.reload();
      //     });
    }
    await this.getAllInversion();
    // this.gettienda();

    // Restaurar búsqueda/paginación si se regresa desde un detalle
    await this.iniciarTablaConFiltros();
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
   
    
    customFormatter(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    
    async changeTypeDates() {
      await this.separarfechas()
    },
    separarfechas() {
      this.fecha_inicio = this.rangode_fecha[0]
      this.fecha_fin = this.rangode_fecha[1]
    },
    // FUNCIONES AUXILIARES
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    //Desactivar registro
    desactivate() {
      const {id, nombre} = this.formPro;
      axios
          .put(process.env.VUE_APP_URL + "productos/desactivate", {
            id: id,
          }, {
            headers: {"x-token": this.userT.token}
          })
          .then(() => {
            this.showModalD = false;
            Vue.toasted.error((nombre + " Desactivado"), this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para desactivar", this.options);
          });
    },
    //Activar registro
    activate() {
      const {id, nombre} = this.formPro;
      // console.log('esta llegando')
      axios
          .put(process.env.VUE_APP_URL + "productos/activate", {
            id: id,
          }, {
            headers: {"x-token": this.userT.token}
          })
          .then(() => {
            this.showModalA = false;
            Vue.toasted.info((nombre + " Activado"), this.options);
            this.$refs.vuetable.refresh();
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
            Vue.toasted.error("Error para activar", this.options);
          });
    },
 
 
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      // console.log(paginationData);
      this.$refs.pagination.setPaginationData(paginationData);
      // Guardar el estado actual de filtros/paginación
      this.persistFiltros();
    },
    // Lógica extra tras restaurar filtros: recargar autos/modelos si aplica
    async afterRestore() {
      if (this.banderaAuto) {
        await this.getAutos();
        if (this.auto && this.auto.id) {
          this.getModelosByAuto(this.auto);
        }
      }
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    async changeTypeSearch(type) {
      this.searchLabel = type;
      // console.log(type);
      this.$refs.vuetable.refresh();
      if (type.value == "auto") {
        this.banderaAuto = true;
        await this.getAutos();
      }else{
        this.banderaAuto = false;
      }
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      const modeloId = this.modelo == 'null' ? 0
                        : this.modelo == null ? 0
                        : this.model == "" ? 0
                        : this.modelo.id;
      const autoId = this.auto == 'null' ? 0
                        : this.auto == null ? 0
                        : this.auto == "" ? 0
                        : this.auto.id;
      return sortOrder[0]
          ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            model : modeloId,
            auto: autoId,
          }
          : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : this.searchLabel.value,

            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
            model : modeloId,
            auto: autoId,
          };
    },
    //AL ABRIR EL MODAL RESETEAR LAS VALIDACIONES Y VARIABLES
    openModal(model) {
      switch (model) {
        case "save": {
          this.$v.$reset();
          this.limpiarVariables();

          // console.log("entrando a resetear")
          break;
        }
        case "update": {
          this.$v.$reset();
          break;
        }
      }
    },
    //Variables que necesitan ser limpiadas para los modales
    limpiarVariables() {
      this.formPro.id = 0;
      /*  this.formPro.categoria = ""; */
      this.formPro.nombre = "";
      this.formPro.descripcion = "";
      this.formPro.subpresentation = [];
      this.formPro.presentacion = [];
    },
    //Cuanso se cierre el modal por cualquier motivo, cerrar los modadles y en actualizar parar loading
    closeModal(model) {
      switch (model) {
        case "save": {
          this.showModalN = false;
          this.showmodalL = false;
          break;
        }
        case "update": {
          this.showModalE = false;
          this.showmodalL = false;
          break;
        }
      }
    },

    //Para abrir los modales y pasar los datos de la fila o limpiar valores
    onActionClicked(action, data) {
      if (action == "print") {
        this.$router.push({
          name: "imprimirproducto",
          params: {departamento: this.ubicacionModel.id, estante: this.estanteModel.id},
          shallow: true,
        });
      }
      if (action == "cardex-item") {
        // console.log(data)
        this.cardexid = data.id;
        this.formPro.idproducto = data.id;
        this.formPro.nombre = data.nombre_producto;
        this.formPro.existencia_actual = data.existencia_stock;
        this.bodegasDisponibles();
      }
      if (action == "history-item") {
        const idhistorial = data.productoId;
        console.log(data);

        this.$router.push({
          name: "historial_precios",
          params: {id: idhistorial},
          shallow: true,
        });
      }
      if (action == "edit-item") {
        console.log(data)
        const idsto = data.id
        const idpro = data.id
        this.$router.push({
          name: "stockproducto",
          params: {id: idpro, opc: 'update', idstock: idsto},
          shallow: true,
        });
      }
      if (action == "new-item") {
        this.$router.push({
          name: "stockproducto",
          params: {id: 0, opc: 'save', idstock: 0},
          shallow: true,
        });
      }
      if (action == "desactivate-item") {
        // console.log(data)
        this.formPro.nombre = data.nombre_producto;
        this.formPro.id = data.id;
        this.showModalD = true
      }
      if (action == "activate-item") {
        this.formPro.nombre = data.nombre_producto;
        this.formPro.id = data.id;
        this.showModalA = true
      }
    },
    async onAdd(){
      this.$v.$touch();
      const me =this;
      console.log(this.formPro.cantidad)
      if (this.formPro.cantidad >= 0  && this.formPro.bodega != '') {
        // console.log('esta if  ')
           if(me.encuentra(this.formPro.bodega.id)){
            Vue.toasted.error("La Ubicación seleccionada ya se encuentra en el detalle", this.options);

          }else{
            // console.log('esta else')
            this.index =    this.arrayDetalle.length > 0? parseInt(this.index) +1 : 0;
            // await this.bodegaSelect(this.formPro.bodega.id);
            // console.log(this.index);
            this.arrayDetalle.push({
                index : this.index,
                tienda : this.formPro.tienda,
                pasillo : this.formPro.pasillo,
                estante : this.formPro.estante,
                ubicacion : this.formPro.bodega.nombre_bodega,
                idstock  :         this.formPro.idproducto,
                idubicacion : this.formPro.bodega.id,
                cantidad : parseFloat(this.formPro.cantidad),
            });
            // console.log(this.arrayDetalle);
            this.formPro.cantidad = ""; 
          }
      }
    },
    async bodegaSelect(producto, bodega) {
      console.log('hola')
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/findByIdInventario?productoId=" + producto + '&bodegaId=' + bodega,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.formPro.pasillo = response.data.data.pasillo;
      this.formPro.estante = response.data.data.estante;
      console.log(   response);
    },
    async getAllInversion() {
      console.log('hola')
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/total_inversion",
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.totalInversion = response.data.data.toFixed(2);
      // console.log(   response);
    },
    encuentra(id){
        let sw = 0;
        for(let i=0; i<this.arrayDetalle.length; i++){
            if(this.arrayDetalle[i].idubicacion==id){
                sw=true;
            }
        }
        return sw;
    },
    eliminarDetalle(data) {
      let me = this;
      // console.log(index);
      // const nuevoindex = index - 1;
      me.arrayDetalle.splice(data.index, 1);
    },
    validacion(){
        if(this.arrayDetalle.length<=0){
          Vue.toasted.error("Debe ingresar los detalles");
        }else{
          this.asignarExistencias();
        }
    },
    limpiarModal(){
      this.arrayDetalle = [];
      this.formPro.idproducto = 0;
        this.formPro.nombre = "";
        this.formPro.existencia_actual = 0;
        this.formPro.descripcion = "";
        this.formPro.cantidad = 0;
        this.formPro.categoria = "";
        this.formPro.marca = null;
        this.formPro.presentacion = "";
        this.formPro.pasillo = '';
        this.formPro.estante = '';
    },
    asignarExistencias(){
       const me = this;
      const {idproducto, nombre}= me.formPro;
      axios
        .put(process.env.VUE_APP_URL + "productos/stock/update_existencia", {
            'detalles' : me.arrayDetalle,
            idproducto,
            'existencia' : this.total,
        },{
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(nombre + "Existencia Guardada", this.options);
          me.$refs.vuetable.refresh();
          this.showModalC = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        });
    },
    //BUSQUEDAS
    async bodegasDisponibles() {
      const tienda = this.userT.tienda;
      const response = await axios.get(
        process.env.VUE_APP_URL + "productos/bodegas_by_tienda?id=" + tienda,
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.arrayBodegas = response.data.bodegas;
      this.formPro.tienda = this.arrayBodegas[0].tienda.nombre_tienda
      // console.log(   this.formPro.tienda );
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    async getAutos(){
      try{
            const response = await axios.get(process.env.VUE_APP_URL + "autos/busqueda",{
            headers: { "x-token": this.userT.token}
          });
            this.arrayAuto = response.data.data;
            // console.log(this.arrayAuto);
        }catch(error){
            console.log(error)
        }
    },
    getModelosByAuto(auto){
      // console.log(auto);
      axios
          .get(process.env.VUE_APP_URL + "autos/busquedasub?auto=" + auto.id, {
            headers: { "x-token": this.userT.token },
          })
          .then((response) => {
            // console.log(response);
            this.arrayModelo = response.data.data;
          })
          .catch((error) => {
            this.errorMessage = error.message;
            console.error("There was an error!", error);
          });
    
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    calcularTotal : function() {
        let resultado = 0.0;
        for(let i=0; i < this.arrayDetalle.length; i++){
            if (this.arrayDetalle[i].cantidad == '') {
                resultado = resultado + 0;
            }
            else {
                resultado = resultado + parseInt(this.arrayDetalle[i].cantidad);
            }
        }
        return resultado.toFixed(2);
    },
  
    /**
     * Total no. of records
     */

  }
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}

</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst"/>

    <div class="row">
      <div class="col-12">

          <!-- Modal para Activar -->
          <b-modal
          centered
          v-model="showModalA"
          title="Activar Categoría"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar el producto?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar el producto?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Loading-->
        <b-modal
            centered
            v-model="showModalL"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
            no-close-on-backdrop
            content-class="my-class"
            header-class="my-class"
        >

          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">

                  <fulfilling-bouncing-circle-spinner
                      :animation-duration="2000"
                      :size="90"
                      color="#2a3042"
                  />
                </div>
              </div>


            </div>


          </form>
        </b-modal>


        <!-- Modal para Modelos-->
        <b-modal
            centered
            ref="modalModelos"
            id="modalModelos"
            title="Modelos"
            no-close-on-backdrop
            v-model="showModalM"
            @hidden="closeModal('modelos')"
            @show="openModal('modelos')"
            title-class="text-black font-18"
            body-class="p-3"
            hide-footer
        >
          <form>
            <div class="row">

              <div class="col-12">
                <b-table-simple responsive>
                  <b-tbody>
                    <tr>
                      <th>Modelo</th>
                      <th>Estado</th>
                    </tr>
                  </b-tbody>
                  <tbody v-if="variosmodelos.length">
                  <tr v-for="(item, index) in variosmodelos" :key="index">

                    <td>{{ item.modelo.auto.nombre_auto }} {{ item.modelo.nombre_modelo }}</td>
                    <td><h5 v-if="item.estado_detalle == true">
                      <span class="badge bg-success ms-1"><strong>ACTIVO</strong></span>
                    </h5>
                      <h5 v-else>
                        <span class="badge bg-danger ms-1"><strong>INACTIVO</strong></span>
                      </h5>
                    </td>
                  </tr>
                  </tbody>
                  <tbody v-else>
                  <tr style="background-color: #CEECF5;">
                    <td colspan="6">
                      No hay registros para mostrar.
                    </td>
                  </tr>
                  </tbody>
                </b-table-simple>
              </div>


            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalM = false">Cerrar</b-button>
            </div>
          </form>
        </b-modal>

        
        <!-- Modal para Asignar bodega -->
        <b-modal
            centered
            v-model="showModalC"
            title="Kardex"
            title-class="text-black font-18"
            body-class="p-3"
            size="lg" 
            hide-footer
        >
          <form @submit.prevent="validacion()">
            <div class="row">
              <div class="col-12">
                
                <div class="mb-3">
                        <label for="name"><strong>Producto:</strong>  {{ formPro.nombre }}</label>
              

                  </div>
                <div class="mb-3">
                        <label for="name"><strong>Tienda:</strong>  {{ this.formPro.tienda}} </label>
                  </div>
                <div class="mb-3">
                        <label for="name"><strong>Existencia Actual:</strong>  {{ this.formPro.existencia_actual}} </label>
                  </div>
                <div class="mb-3">
                  <label for="name">Ubicaciones </label>
                  <v-select v-model.trim="formPro.bodega"  @input="bodegaSelect(formPro.idproducto,formPro.bodega.id)" :options="arrayBodegas" label="nombre_bodega">
                    
                  </v-select>
                </div>
                <input
                              id="name"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese el pasillo"
                              v-model.trim="formPro.pasillo"
                            />
                            <br>
                <input
                              id="name"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese el estante"
                              v-model.trim="formPro.estante"
                            />
                <b-form-group label="Cantidad a ingresar:">
                <b-input-group class="mb-3">
                  <input
                    id="name"
                    v-model="formPro.cantidad"
                    type="number"
                    class="form-control"
                    placeholder="Ingrese una cantidad"
                  />
                  <b-button variant="primary default" @click="onAdd"
                                    >Agregar</b-button>
                                  </b-input-group>
                                </b-form-group>
                
              </div>
            </div>
             <!-- Table -->
             <Loader :loading="loadingtable">
              <b-table
          small
          striped
          v-if="arrayDetalle.length > 0"
          ref="table"
          :items="arrayDetalle"
          :fields="cabezera"
        >
        <template #cell(tienda)="data">
            {{ data.item.tienda }}
          </template>
          <template #cell(producto)="data">
            {{ data.item.ubicacion }}
          </template>
          <template #cell(cantidad)="data">
            {{ data.item.cantidad }}
          </template>
          <template #cell(pasillo)="data">
            {{ data.item.pasillo }}
          </template>
          <template #cell(estante)="data">
            {{ data.item.estante }}
          </template>
          <template #cell(opciones)="data">
            <b-button
              tabindex="0"
              v-b-tooltip.focus
              title="Eliminar"
              class="icon-content col-xl-8 col-lg-4 col-sm-"
              size="sm"
              variant="outline-danger"
              @click="eliminarDetalle(data)"
              ><i :class="'bx bx-trash-alt'"
            /></b-button>
          </template>
        </b-table>
            </Loader>
            <div class="row">
            <div class="col">
              <b-card bg-variant="primary" class="text-white-20 bg-gradient">
                <h2 class="mt-0 mb-4 text-white">
                  <i class="bx bx-list-check me-3"></i> Existencias Nuevas 
                </h2>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{ calcularTotal }}
                </h3>
               
              </b-card>
              <b-card bg-variant="primary" class="text-white-20 bg-gradient">
                <h2 class="mt-0 mb-4 text-white">
                  <i class="bx bx-list-check me-3"></i> Existencias Totales 
                </h2>
                <h3 class="mt-0 mb-4 text-white" align="center">
                  {{total = (parseFloat(calcularTotal) + parseFloat(formPro.existencia_actual))}}
                </h3>
               
              </b-card>
            </div>
            </div>
            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalC = false">Cancelar</b-button>
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>


        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Productos</h4>
            <div class="row">
  <div class="col-sm-6 text-md-end">
    <div v-if="userT.role == 1 || userT.role == '1'" class="mt-2 p-3" style="background-color: #f0f8ff; border: 1px solid #d1e7dd; border-radius: 8px;">
      <strong class="text-primary" style="font-size: 1.5rem;">Inversión:</strong>
      <span class="text-success" style="font-size: 1.5rem;">{{ money(totalInversion) }}</span>
    </div>
  </div>
</div>


            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        @input="changePageSize()"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2 ">
                <div id="tickets-table_length" class="dataTables_length text-md-end ">
                  <label class="d-inline-flex align-items-center">

                    <b-dropdown
                        v-if="searchType"
                        id="ddown1"
                        size="sm"
                    >
                      <template v-slot:button-content>
                        {{ 'Ordenar por: ' + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                          v-for="(search, index) in searchType"
                          :key="index"
                          @click="changeTypeSearch(search)"
                      >{{ search.nombre }}
                      </b-dropdown-item
                      >
                   
                    </b-dropdown>
                   
                  </label>
          
                </div>
                
              </div>
          
              <div class="col-sm-12 col-md-3">
  <div id="tickets-table_length" class="dataTables_length d-flex flex-column">
    <!-- Campo de búsqueda -->
    <label class="d-inline-flex align-items-center mb-2">
      <b-form-input
        v-model="search"
        type="search"
        @input="onFiltered()"
        placeholder="Buscar..."
        class="form-control form-control-sm"
      ></b-form-input>
    </label>
    
    <!-- Inversión (solo para ciertos roles) -->
    
  </div>
  </div>

            
              <div class="col-sm-12 col-md-5">
                
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                        type="button"
                        class="btn btn-success btn-rounded mb-2 me-2"
                        @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nuevo Producto
                    </button>
                  </label>
                  <div v-if="banderaAuto" class="d-flex flex-row w-100">
                      <v-select
                        v-model.trim="auto"
                        :options="arrayAuto"
                        @input="getModelosByAuto(auto), onFiltered()"
                        label="nombre_auto"
                        class="w-100 me-2 form-control-lg"
                      ></v-select>
                      <v-select
                        v-model.trim="modelo"
                        @input="onFiltered()"
                        :options="arrayModelo"
                        label="nombre_modelo"
                        class="w-100 form-control-lg"
                      ></v-select>
                    </div>
                </div>

              </div>


              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <!-- Desktop (>= md): tabla -->
              <div class="d-none d-lg-block">
              <vuetable ref="vuetable"
                        class="table-divided table-responsive order-with-arrow"
                        :css="css.table"
                        :http-options="httpOptions"
                        :api-url="apiBase"
                        :reactive-api-url="true"
                        :fields="fields"
                        :per-page="perPage"
                        :query-params="makeQueryParams"
                        :load-on-start="false"
                        pagination-path
                        @vuetable:pagination-data="onPaginationData">
                <div slot="actions" slot-scope="props">
                  <b-dropdown variant="primary">
                    <template v-slot:button-content>
                      Opciones
                      <i class="mdi mdi-chevron-down"></i>
                    </template>
                    <b-dropdown-item-button v-if="props.rowData.producto.estado_producto"
                                            @click="onActionClicked('edit-item', props.rowData.producto)"><i
                        class="bx bx-edit-alt"></i> Editar
                    </b-dropdown-item-button>
                    <router-link
                        :to="{
                        name: 'viewstock',
                        params: { id: props.rowData.producto.id },
                      }"
                    >
                      <b-dropdown-item-button v-if="props.rowData.producto.estado_producto"><i :class="'bx bxs-show'"/> Ver
                        mas
                      </b-dropdown-item-button>
                    </router-link>
                    <b-dropdown-item-button v-if="props.rowData.producto.estado_producto"
                                            @click="onActionClicked('history-item', props.rowData)"><i
                        class="fas fa-history"></i> Historial precios
                    </b-dropdown-item-button>
                    <b-dropdown-item-button v-if="props.rowData.producto.estado_producto"
                                            @click="onActionClicked('cardex-item', props.rowData.producto),showModalC=true;">
                      <i class="bx bx-credit-card"></i> Asignar bodega
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="
                  props.rowData.producto.estado_producto == true
                    ? onActionClicked('desactivate-item', props.rowData.producto)
                    : onActionClicked('activate-item', props.rowData.producto);
                "><i :class="
                  props.rowData.producto.estado_producto == true
                      ? 'bx bx-trash-alt'
                      : 'bx bx-list-check'"></i>{{ props.rowData.producto.estado_producto ? " Desactivar" : " Activar" }}
                    </b-dropdown-item-button>
                  </b-dropdown>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.producto.estado_producto == true">

                    <span class="badge bg-success ms-1"><strong>ACTIVO</strong></span>
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"><strong>INACTIVO</strong></span>
                  </h5>
                </div>
                <div  v-if="userT.role == 1 || userT.role == '1'"  slot="precio_compra" slot-scope="props">
                  {{
                    money(props.rowData.producto.precio_compra)
                  }}
                </div>
                <div slot="Img" slot-scope="props">
                  <img
                      :src="(apiUrl + 'productos/get/imagen/' + props.rowData.producto.imagen_stock  )"
                      class="list-thumbnail responsive border-0 rounded-corners"
                      width="70%"
                  />
                </div>

                <div slot="precio_venta" slot-scope="props">
                  {{
                    money(props.rowData.producto.precio_venta)
                  }}
                </div>
                <div slot="categoria" slot-scope="props">
                  {{
                    (props.rowData.producto.categoria.nombre_categoria)
                  }}
                </div>
                <div slot="marca" slot-scope="props">
                  {{
                    (props.rowData.producto.marca.nombre_marca)
                  }}
                </div>
                <div slot="modelo" slot-scope="props">

                  <b-button
                      tabindex="0" v-b-tooltip.focus title="Ver Modelos" variant="outline-secondary"
                      @click="modelos_s(props.rowData.producto.id)"
                  >
                    <i :class="'bx bxs-show'"/>
                  </b-button>
                </div>
              </vuetable>
              </div>

              <!-- Móvil (< md): cards -->
              <ResponsiveCards :items="items">
                <template #card="{ item }">
                  <div class="rwd-card__head">
                    <span v-if="item.producto.estado_producto" class="badge bg-success">ACTIVO</span>
                    <span v-else class="badge bg-danger">INACTIVO</span>
                    <b-dropdown variant="primary" size="sm" right>
                      <template v-slot:button-content>
                        Opciones <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item-button v-if="item.producto.estado_producto"
                        @click="onActionClicked('edit-item', item.producto)">
                        <i class="bx bx-edit-alt"></i> Editar
                      </b-dropdown-item-button>
                      <router-link :to="{ name: 'viewstock', params: { id: item.producto.id } }">
                        <b-dropdown-item-button v-if="item.producto.estado_producto">
                          <i class="bx bxs-show"></i> Ver más
                        </b-dropdown-item-button>
                      </router-link>
                      <b-dropdown-item-button v-if="item.producto.estado_producto"
                        @click="onActionClicked('history-item', item)">
                        <i class="fas fa-history"></i> Historial precios
                      </b-dropdown-item-button>
                      <b-dropdown-item-button v-if="item.producto.estado_producto"
                        @click="onActionClicked('cardex-item', item.producto), showModalC=true;">
                        <i class="bx bx-credit-card"></i> Asignar bodega
                      </b-dropdown-item-button>
                      <b-dropdown-item-button @click="
                        item.producto.estado_producto == true
                          ? onActionClicked('desactivate-item', item.producto)
                          : onActionClicked('activate-item', item.producto);">
                        <i :class="item.producto.estado_producto == true ? 'bx bx-trash-alt' : 'bx bx-list-check'"></i>{{ item.producto.estado_producto ? " Desactivar" : " Activar" }}
                      </b-dropdown-item-button>
                    </b-dropdown>
                  </div>
                  <div class="rwd-card__title">{{ item.producto.nombre_producto }}</div>
                  <div class="rwd-card__sub">Código: {{ item.producto.codigo_stock }}</div>
                  <div class="d-flex align-items-baseline justify-content-between mt-1">
                    <span class="rwd-card__value">{{ money(item.producto.precio_venta) }}</span>
                    <span class="rwd-card__sub">Existencia: {{ item.existencia }}</span>
                  </div>
                  <div class="rwd-card__meta">
                    <span>{{ item.producto.marca.nombre_marca }} · {{ item.producto.categoria.nombre_categoria }}</span>
                    <span>Est. {{ item.estante }} / Pas. {{ item.pasillo }}</span>
                  </div>
                </template>
              </ResponsiveCards>

              <div style="padding-top:10px">
                <vuetable-pagination ref="pagination"
                                     :css="css.pagination"
                                     @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>

            </Loader>

          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>